
/*
 Author: Vinod
 Date: 03/03/2020
 Issue Description:  Instead of "Value" It shows the criteria chosen in the label.
 search_string: PL_2869
*/


<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <br />

    <tl-header type="h1">
      <div class="main-header margintop-10">Fixed Non-CTC Components</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="margintop-10" :disabled="!ifTeamleaderAnchorPermission">
      <div class="uploadMethoRadio">
        <tl-radio
          name="uploadType"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />
        <tl-radio
          name="uploadType"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
      </div>
    </div>

    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div v-if="uploadMethod == 'manualUpload'">
      <div>
        <div class="row-container margintop-30">
          <div class="row">
            <div class="col-3 padding-l-n" :disabled="!ifTeamleaderAnchorPermission">
              <search-dropdown
                class="custom-width-search margin-t-15px"
                :placeholder="'Search Employee Name'"
                :clearRequired="true"
                :employeeData="employeeData"
                @clear="(val) =>{selectedEmployee = {};}"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp)=>selectedEmp(emp)"
              />
            </div>
          </div>
          <div class="row-container end" @click="showPopup = !showPopup " v-if="selectedEmployee.id != null">
            <img src="@/assets/group-5.svg" class="Group-5" />
            <button class="text-green">Add New Component</button>
          </div>
        </div>

        <div class="margintop-10" v-if="selectedEmployee.id != null">
          <tl-tabs :tabs="tabs" :customclass="true" class="margintop-20">
            <tl-tab>
              <data-table
                :columns="employeeTableColumns"
                :tableData="employeeList.active"
                :checkbox="false"
                :withForm="false"
                :showhistory="false"
                :showdelete="false"
                @editStart="initEditStartActive"
                :search="search"
              >
                <template v-slot:rowcontent="slotprops">
                  <p
                    v-if="slotprops.value.column.key=='salary_component_code'"
                  >{{slotprops.value.record[slotprops.value.column.key]}}</p>

                  <p
                    v-if="slotprops.value.column.key=='value'"
                  >Rs. {{slotprops.value.record[slotprops.value.column.key]}}</p>

                  <div v-if="slotprops.value.column.key=='from'">
                      <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
                  </div>

                  <div v-if="slotprops.value.column.key=='to'">
                      <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
                  </div>
                </template>
              </data-table>
            </tl-tab>
            <tl-tab>
              <data-table
                :columns="employeeTableColumns"
                :tableData="employeeList.scheduled"
                :checkbox="false"
                :withForm="false"
                :showhistory="false"
                :showdelete="false"
                @editStart="initEditStartScheduled"
                :search="search"
              >
                <template v-slot:rowcontent="slotprops">
                  <p
                    v-if="slotprops.value.column.key=='salary_component_code'"
                  >{{slotprops.value.record[slotprops.value.column.key]}}</p>

                  <p
                    v-if="slotprops.value.column.key=='value'"
                  >Rs. {{slotprops.value.record[slotprops.value.column.key]}}</p>

                  <div v-if="slotprops.value.column.key=='from'">
                      <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
                  </div>

                  <div v-if="slotprops.value.column.key=='to'">
                      <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
                  </div>
                </template>
              </data-table>
            </tl-tab>
            <tl-tab>
              <data-table
                :columns="employeeTableColumns"
                :tableData="employeeList.expired"
                :checkbox="false"
                :withForm="false"
                :showhistory="false"
                :showdelete="false"
                @editStart="initEditStartExpired"
                :search="search"
              >
                <template v-slot:rowcontent="slotprops">
                  <p
                    v-if="slotprops.value.column.key=='salary_component_code'"
                  >{{slotprops.value.record[slotprops.value.column.key]}}</p>

                  <p
                    v-if="slotprops.value.column.key=='value'"
                  >Rs. {{slotprops.value.record[slotprops.value.column.key]}}</p>

                  <div v-if="slotprops.value.column.key=='from'">
                      <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
                  </div>

                  <div v-if="slotprops.value.column.key=='to'">
                      <span>{{formatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
                  </div>
                </template>
              </data-table>
            </tl-tab>
          </tl-tabs>
        </div>
      </div>
      <pop-up-window
                v-if="showPopup && selectedEmployee.id != null"
                @back="showPopup = !showPopup"
                :header="headerTextWindow">

                <template v-slot:content>
                  <component-assign :empId="selectedEmployee" @back="showPopup = !showPopup"></component-assign>
                </template>

      </pop-up-window>
    </div>
    <div v-else>
      <div class="download-btn marginbot-20">
        <download-button
          onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/EmployeeFixedNonCtc.xlsx'"
        ></download-button>
      </div>
      <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" :params="requestParams" />
    </div>

    <footer>
      <bottom-action-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="cancel" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ComponentAssign from "./assignNonCTCcomponentsToEmployees.vue";
import { api_variables } from "@/apis/variables.js";

export default {
  components: {
    ComponentAssign
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Fixed Non-CTC Components",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assignFixedNonCtcComponents`
        }
      ],

      uploadMethod: "manualUpload",
      errmsg: "",
      toast: false,
      search: "",
      currentMonthValue: "",
      subCriteriaLabel: "", // PL_2869
      body: {
        legal_entity_id: this.le_id,
        paygroups: [],
        bands: [],
        bunits: [],
        locs: [],
        cost_centers: []
      },

      formData: {
        payGroupObj: null,
        criteriaObj: null,
        valueObj: null
      },

      criteriaArray: [
        { name: "Location" },
        { name: "Salary Band" },
        //{ name: "Grade" },
        { name: "Cost Centre" },
        { name: "BUs" }
      ],

      valueArray: [],

      payGroupsList: [],

      criteriaList: [],

      valueList: [],

      employeeTableColumns: [
        {
          label: "Component",
          key: "salary_component_code"
        },
        {
          label: "Applicable from",
          key: "from"
        },
        {
          label: "Applicable till",
          key: "to"
        },
        {
          label: "Amount per month",
          key: "value"
        }
      ],

      employeeList: [],

      monthOptions: [
        { name: "January", id: "jan" },
        { name: "February", id: "feb" },
        { name: "March", id: "march" },
        { name: "April", id: "apr" },
        { name: "May", id: "may" },
        { name: "June", id: "june" },
        { name: "July", id: "july" },
        { name: "August", id: "aug" },
        { name: "September", id: "sept" },
        { name: "October", id: "oct" },
        { name: "November", id: "nov" },
        { name: "December", id: "dec" }
      ],
      activeComponentsCountArray: [],
      tabs: [
        {
          header: "Active"
        },
        {
          header: "Scheduled"
        },
        {
          header: "Expired"
        }
      ],
      showPopup: false,
      employeeData: [],
      selectedEmployee: {},
      bulkUploadUrl: api_variables.SERVICE_EMPLOYEES_BULK_NON_CTC,
      assignFixedNonCtcComponentValue: false,
      role: ""
    };
  },

  activated() {
    this.refresh();
    this.uploadMethod = "manualUpload";
    var today = new Date();
    let currentMonthIndex = today.getMonth();
    this.currentMonthValue = this.monthOptions[currentMonthIndex].name;
    // this.fetchEmplDetails();
    this.getOrgLeIdList();
  },

  computed: {
    ...mapState({
      business_units: state => state.onboard.business_units.data,
      salary_bands: state => state.onboard.salary_bands.data,
      locations: state => state.onboard.locations.data,
      salary_grades: state => state.onboard.salary_grades.data,
      cost_centres: state => state.onboard.cost_centres.data,
      employees: state => state.onboard.employees.entityWiseData,

      globalEmployeeList: state =>
        state.globalapi.globalemployees.entityWiseData
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    headerTextWindow() {
      if (this.selectedEmployee) {
        return `Add Fixed Non-CTC Component: ${ this.selectedEmployee.first_name }`;
      } else {
        return `Add Fixed Non-CTC Component: ${ this.selectedEmployee.first_name }`;
      }
    },
    requestParams() {
      return {
        le_id: this.le_id
      };
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.assignFixedNonCtcComponentValue) {
          return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },

  methods: {
    ...mapActions({
      fetch_assigned_components: "dashboard/payroll/utilities/get_fbp/fetchAll",
      assign_component:
        "dashboard/payroll/utilities/assignfbpcomponents/create",
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      fetchNonCtcComponents:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/fetchNonCtcComponents",
      act_changeEditMode:
        "dashboard/payroll/utilities/assignFixedNonCTCcomponents/changeEditMode",

      act_locations_fetchAll: "onboard/locations/fetchAll",
      act_costCenters_fetchAll: "onboard/cost_centres/fetchAll",
      act_salaryBands_fetchAll: "onboard/salary_bands/fetchAll",
      act_businessUnits_fetchAll: "onboard/business_units/fetchAll",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
    }),

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    edit(record) {},

    unAssign(record) {},

    async fetchEmplDetails() {
      this.employeeList = [];
      try {
        // this.body.legal_entity_id = this.le_id;
        //
        // let res = await this.fetchEmployeesNonCtcComponents(
        //   this.body
        // );
        // if (res.status) {
        //   let empList = res.data.payload.data;
        //   if (empList.length) {
        //     for (let employee of empList) {
        //       employee["photo_url"] = employee.photo_url ? employee.photo_url : require("@/assets/user.svg");
        //       employee["showDropDown"] = false;
        //       employee["amount"] = [];
        //       employee["components"] = [];
        //       employee["applicableFrom"] = [];
        //       employee["applicableTo"] = [];
        //       employee["componentsCount"] = "0";
        //       employee["totalAmount"] = "0";
        //
        //
        //         if (employee.EmployeeFixedNonCTCComponent && employee.EmployeeFixedNonCTCComponent.length) {
        //             let salary_component_array =
        //               employee.EmployeeFixedNonCTCComponent;
        //
        //             let component_total_amount = Number(0);
        //             let components_total_active = 0;
        //
        //             for (let salary_component of salary_component_array) {
        //               if (salary_component.status == "Active") {
        //                 if (salary_component.advanced_setting) {
        //                   let advanceSettingArray =
        //                     salary_component.advanced_setting;
        //                   let advanced_settings_amount = 0;
        //
        //                   if (advanceSettingArray.length) {
        //                     advanceSettingArray.forEach(item => {
        //                       advanced_settings_amount =
        //                         Number(advanced_settings_amount) +
        //                         Number(item.amount);
        //                     });
        //
        //                     component_total_amount =
        //                       Number(component_total_amount) +
        //                       Number(advanced_settings_amount);
        //                   } else {
        //                     d;
        //                     component_total_amount =
        //                       Number(component_total_amount) + 0;
        //                   }
        //                 } else {
        //                   component_total_amount =
        //                     Number(component_total_amount) +
        //                     Number(salary_component.amount);
        //                 }
        //               }
        //
        //               components_total_active =
        //                 components_total_active +
        //                 (salary_component.status == "Active" ? 1 : 0);
        //               employee["amount"].push(salary_component.amount);
        //               employee["components"].push(salary_component.name);
        //               employee["applicableFrom"].push(
        //                 salary_component.applicable_from
        //               );
        //               employee["applicableTo"].push(
        //                 salary_component.applicable_to
        //               );
        //             }
        //
        //             employee["componentsCount"] = components_total_active; //salary_component_array.length;
        //             employee["totalAmount"] = component_total_amount;
        //             this.activeComponentsCountArray.push(
        //               component_total_amount
        //             );
        //           }
        //           this.employeeList.push(employee);
        //         }

              /** Commented for future reference because of few doubts */
              /* Commented for future reference because of few doubts
              if (employee.EmployeeNonCTCComponent) {
                if (employee.EmployeeNonCTCComponent.salary_component) {
                  if (
                    employee.EmployeeNonCTCComponent.salary_component.length
                  ) {
                    let salary_component_array =
                      employee.EmployeeNonCTCComponent.salary_component;

                    let component_total_amount = Number(0);
                    let components_total_active = 0;

                    for (let salary_component of salary_component_array) {
                      if (salary_component.status == "Active") {
                        if (salary_component.advanced_setting) {
                          let advanceSettingArray =
                            salary_component.advanced_setting;
                          let advanced_settings_amount = 0;

                          if (advanceSettingArray.length) {
                            advanceSettingArray.forEach(item => {
                              advanced_settings_amount =
                                Number(advanced_settings_amount) +
                                Number(item.amount);
                            });

                            component_total_amount =
                              Number(component_total_amount) +
                              Number(advanced_settings_amount);
                          } else {
                            d;
                            component_total_amount =
                              Number(component_total_amount) + 0;
                          }
                        } else {
                          component_total_amount =
                            Number(component_total_amount) +
                            Number(salary_component.amount);
                        }
                      }

                      components_total_active =
                        components_total_active +
                        (salary_component.status == "Active" ? 1 : 0);
                      employee["amount"].push(salary_component.amount);
                      employee["components"].push(salary_component.name);
                      employee["applicableFrom"].push(
                        salary_component.applicable_from
                      );
                      employee["applicableTo"].push(
                        salary_component.applicable_to
                      );
                    }

                    debugger;
                    employee["componentsCount"] = components_total_active; //salary_component_array.length;
                    employee["totalAmount"] = component_total_amount;
                    this.activeComponentsCountArray.push(
                      component_total_amount
                    );
                  }
                }
              }
              */
              //employee["salary_component"] = employee.EmployeeNonCTCComponent ? employee.EmployeeNonCTCComponent.salary_component : [];
              //this.employeeList.push(employee);
          //   }
          // }
        // if (this.employees[this.le_id].length) {
        //   for (let employee of this.this.employees[this.le_id]) {
        //     employee["imgSrc"] = require("@/assets/user.svg");
        //     employee["showDropDown"] = false;
        //     this.employeeList.push(employee);
        //   }
        // }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    onUploadTemplate() {
      try {
        let formData = new FormData();
        formData.append("file", event);
        formData.append("le_id", this.le_id);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to select employee */
    async selectedEmp(emp) {
      try {
        this.selectedEmployee = emp
        this.empId = emp.id;
        this.empCode = emp.code;
        this.empName = emp.first_name + ' ' + emp.last_name;   // PL_3009
        this.empMail = emp.email_id;
        let res = await this.fetchNonCtcComponents(emp.id);
        this.employeeList = res.data.payload.data;
        // if (this.typeOfLoss) {
        //   this.fetchAll();
        // }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val
        });
        this.employeeData = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async changeCriteria(event) {
      try {
        if (event) {
          this.valueArray = [];
          this.formData.criteriaObj = event;
          this.formData.valueObj = [];
          this.subCriteriaLabel = event.name; // PL_2869
          if (event.name == "Location") {
            try {
              let res = await this.act_locations_fetchAll(this.le_id);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.locations[this.le_id]
              ? this.locations[this.le_id]
              : [];
          } else if (event.name == "Salary Band") {
            try {
              let res = await this.act_salaryBands_fetchAll(this.le_id);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.salary_bands[this.le_id]
              ? this.salary_bands[this.le_id]
              : [];
          } else if (event.name == "Grade") {
            this.valueArray = this.salary_grades[this.le_id]
              ? this.salary_grades[this.le_id]
              : [];
          } else if (event.name == "Cost Centre") {
            try {
              let res = await this.act_costCenters_fetchAll(this.le_id);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.cost_centres[this.le_id]
              ? this.cost_centres[this.le_id]
              : [];
          } else if (event.name == "BUs") {
            try {
              let res = await this.act_businessUnits_fetchAll(this.orgId);
            } catch (err) {
              this.toast = true;
              this.errmsg = err;
            }

            this.valueArray = this.business_units.data
              ? this.business_units.data
              : [];
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    changeValue(event) {
      try {
        if (event) {
          this.body.locs = [];
          this.body.bands = [];
          this.body.bunits = [];
          this.body.cost_centers = [];

          let valueArr = event;

          if (this.formData.criteriaObj.name == "Location") {
            valueArr.forEach(item => {
              this.body.locs.push(item.id);
            });
          } else if (this.formData.criteriaObj.name == "Salary Band") {
            valueArr.forEach(item => {
              this.body.bands.push(item.id);
            });
          } else if (this.formData.criteriaObj.name == "Cost Center") {
            valueArr.forEach(item => {
              this.body.cost_centers.push(item.id);
            });
          } else if (this.formData.criteriaObj.name == "BUs") {
            valueArr.forEach(item => {
              this.body.bunits.push(item.id);
            });
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    payGroupChanged(event) {
      this.body.paygroups = [event.id];
    },

    filterData(searchText) {
      this.search = searchText;
    },

    filterList() {
      // this.fetchEmplDetails();
    },

    async initEditStartActive(record) {
      try {
        let selectedindex = this.employeeList.active.findIndex(
          item => item.id == record.id
        );

        if (selectedindex > -1) {
          try {
            await this.act_changeEditMode({
              editMode: true,
              record: record,
              index: selectedindex
            });
            this.$router.push({
              path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
            });
          } catch (err) {
            this.toast = true;
            this.errmsg = err.message;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

     async initEditStartScheduled(record) {
      try {
        let selectedindex = this.employeeList.scheduled.findIndex(
          item => item.id == record.id
        );

        if (selectedindex > -1) {
          try {
            await this.act_changeEditMode({
              editMode: true,
              record: record,
              index: selectedindex
            });
            this.$router.push({
              path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
            });
          } catch (err) {
            this.toast = true;
            this.errmsg = err.message;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

     async initEditStartExpired(record) {
      try {
        let selectedindex = this.employeeList.expired.findIndex(
          item => item.id == record.id
        );

        if (selectedindex > -1) {
          try {
            await this.act_changeEditMode({
              editMode: true,
              record: record,
              index: selectedindex
            });
            this.$router.push({
              path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
            });
          } catch (err) {
            this.toast = true;
            this.errmsg = err.message;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    formatDate(date) {
      let dateJsObj = new Date(date);
      return `${dateJsObj.getDate()}/${dateJsObj.getMonth()+1}/${dateJsObj.getFullYear()}`;
    },

    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
      // });
    },

    refresh() {
      try {
        this.formData = {
          payGroupObj: null,
          criteriaObj: null,
          valueObj: null
        };
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.assignFixedNonCtcComponentValue = data.data.user.permissions.assign_fixed_non_ctc_component ? true : false;
        //console.log("PL-3406",data);
      }
  }
};
</script>
<style lang="scss" scoped>

.tabs .tab-container {
  padding: none;
}

.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #6e6e6e;
}

.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}

.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}

.customColumnGrid {
  display: grid;
  grid-template-columns: 15% 15% 15% 15%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}

.emp-image{
    width: 80px;
    height: 80px;
    border-radius: 40px;
}
.end {
  justify-content: flex-end;
}

.Group-5{
  height: 75px;
  width: 25px;
}
.text-green {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
